module.exports = __webpack_public_path__ + "sb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sb.svg
// module id = 1044
// module chunks = 0